<template lang="pug">
  .svg-icon.icon(v-html="require(`assets/icons/${icon}.svg`)")
</template>

<style module>
.svg-icon {
  display: inline-block;
}

.svg {
  fill: currentColor;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}
</style>

<script>
export default {
  props: {
    icon: { type: String, required: true },
  },
  mounted() {
    this.$el.firstChild.classList.add(this.$style.svg)
    this.$el.firstChild.removeAttribute('height')
    this.$el.firstChild.removeAttribute('width')
  },
}
</script>
